module.exports = __webpack_public_path__ + "static/mainBg-a2ea1d1c8e0e0c150009d6ed4e8fc2ac.jpg";